var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lite-file" }, [
    _c("div", {
      staticStyle: { display: "none" },
      attrs: { id: "liteFileElement" }
    }),
    _vm._v(" "),
    !_vm.$store.state.curDriveId
      ? _c("div", { staticClass: "lite-drive-box" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: false,
                  expression: "false"
                }
              ],
              staticClass: "lite-drive-box-btns"
            },
            [
              _c(
                "button",
                {
                  staticClass: "addCloudIcon addCloudIconLite",
                  on: {
                    click: function($event) {
                      return _vm.addCloud()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.common.addCloud")))]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "lite-drive-items myscroll" },
            [
              _vm._l(_vm.spaceDrives, function(drive) {
                return _c(
                  "div",
                  {
                    key: drive.id,
                    class:
                      "lite-drive-item" +
                      (_vm.curCloudId == drive.id
                        ? " lite-drive-item-select"
                        : ""),
                    attrs: { title: drive.errorMsg },
                    on: {
                      dblclick: function($event) {
                        return _vm.openDrive(drive.id)
                      },
                      click: function($event) {
                        _vm.curCloudId = drive.id
                      }
                    }
                  },
                  [
                    _c("div", {
                      class: "drive-item-icon drive-icon-" + drive.type
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "drive-item-info" },
                      [
                        _c("div", { staticClass: "drive-item-name" }, [
                          _vm._v(_vm._s(drive.name))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "drive-item-prog" }, [
                          _c("div", {
                            staticClass: "drive-item-prog-item",
                            style: {
                              width: _vm.getDriveSpace(drive),
                              backgroundColor: _vm.getDriveSpaceColor(drive)
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "drive-item-space" }, [
                          _c("span", [_vm._v(_vm._s(_vm.getDriveInfo(drive)))])
                        ]),
                        _vm._v(" "),
                        _c("el-link", {
                          staticClass: "drive-item-load",
                          attrs: {
                            icon: drive.loadDriveInfo
                              ? "el-icon-loading"
                              : "el-icon-refresh-right",
                            underline: false
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.loadDriveInfo(drive)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              }),
              _vm._v(" "),
              _vm.noSpaceDrives.length > 0
                ? _c("div", { staticClass: "lite-drive-item-line" })
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.noSpaceDrives, function(drive) {
                return _c(
                  "div",
                  {
                    key: drive.id,
                    class:
                      "lite-drive-item lite-drive-item-no-space" +
                      (_vm.curCloudId == drive.id
                        ? " lite-drive-item-select"
                        : ""),
                    on: {
                      dblclick: function($event) {
                        return _vm.openDrive(drive.id)
                      },
                      click: function($event) {
                        _vm.curCloudId = drive.id
                      }
                    }
                  },
                  [
                    _c("div", {
                      class: "drive-item-icon drive-icon-" + drive.type
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "drive-item-name" }, [
                      _vm._v(_vm._s(drive.name))
                    ])
                  ]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "lite-drive-footer" }, [
            _c("div", { staticClass: "drive-count" }, [
              _vm._v(
                "Clouds: " +
                  _vm._s(
                    _vm.$store.state.drives.length -
                      _vm.countFTP -
                      _vm.countWebDAV -
                      _vm.countDB
                  )
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "drive-count" }, [
              _vm._v("FTP: " + _vm._s(_vm.countFTP))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "drive-count" }, [
              _vm._v("WebDAV: " + _vm._s(_vm.countWebDAV))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "drive-count" }, [
              _vm._v("DB: " + _vm._s(_vm.countDB))
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false"
                  }
                ],
                on: {
                  click: function($event) {
                    return _vm.loadAllDriveInfo()
                  }
                }
              },
              [_vm._v("Load All Drive Info")]
            )
          ])
        ])
      : _c(
          "div",
          {
            staticClass: "lite-file-box",
            on: {
              dragover: function($event) {
                $event.preventDefault()
              },
              drop: function($event) {
                $event.preventDefault()
                return _vm.onDrop($event)
              }
            }
          },
          [
            _vm.$store.state.curDriveId
              ? _c(
                  "el-breadcrumb",
                  {
                    staticClass: "folder-nav",
                    attrs: { "separator-class": "el-icon-arrow-right" }
                  },
                  [
                    _c("el-breadcrumb-item", [
                      _c("span", {
                        staticClass: "folder-nav-home home-page-icon",
                        on: {
                          click: function($event) {
                            return _vm.showDrives()
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("el-breadcrumb-item", [
                      _c(
                        "span",
                        {
                          staticClass: "folder-nav-span",
                          attrs: {
                            title: _vm.getDrive(_vm.$store.state.curDriveId)
                              .name
                          },
                          on: {
                            click: function($event) {
                              return _vm.openFolder(
                                _vm.$store.state.curDriveId,
                                null,
                                null
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.getDrive(_vm.$store.state.curDriveId).name
                            )
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.getNodeArr(_vm.$store.state.curNode), function(
                      node
                    ) {
                      return _c("el-breadcrumb-item", { key: node.id }, [
                        _c(
                          "span",
                          {
                            staticClass: "folder-nav-span",
                            attrs: { title: node.name },
                            on: {
                              click: function($event) {
                                return _vm.openFolder(
                                  _vm.$store.state.curDriveId,
                                  node,
                                  null
                                )
                              }
                            }
                          },
                          [_vm._v(_vm._s(node.name))]
                        )
                      ])
                    })
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showRightMenu
              ? _c(
                  "div",
                  {
                    ref: "rightMenu",
                    staticClass: "right-menus",
                    style: {
                      left: _vm.rightMenuX + "px",
                      top: _vm.rightMenuY + "px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showUpload(),
                            expression: "showUpload()"
                          }
                        ],
                        staticClass: "options-button",
                        on: {
                          click: function($event) {
                            return _vm.triggerUpload()
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "options-button-icon lite-upload"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "options-button-text" }, [
                          _vm._v(
                            _vm._s(_vm.$t("language.cloudExploer.uploadFile"))
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showBucket(),
                            expression: "showBucket()"
                          }
                        ],
                        staticClass: "options-button",
                        on: {
                          click: function($event) {
                            return _vm.triggerBucket()
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "options-button-icon lite-bucket"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "options-button-text" }, [
                          _vm._v(
                            _vm._s(_vm.$t("language.cloudExploer.newBucket"))
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showMkdir(),
                            expression: "showMkdir()"
                          }
                        ],
                        staticClass: "options-button",
                        on: {
                          click: function($event) {
                            return _vm.triggerMkdir()
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "options-button-icon lite-mkdir"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "options-button-text" }, [
                          _vm._v(
                            _vm._s(_vm.$t("language.cloudExploer.newFolder"))
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showTranTo(),
                            expression: "showTranTo()"
                          }
                        ],
                        staticClass: "options-button",
                        on: {
                          click: function($event) {
                            return _vm.selectTaskTo("tran")
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "options-button-icon lite-tran-to"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "options-button-text" }, [
                          _vm._v(_vm._s(_vm.$t("language.common.tranTo")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showSyncWith(),
                            expression: "showSyncWith()"
                          }
                        ],
                        staticClass: "options-button",
                        on: {
                          click: function($event) {
                            return _vm.selectTaskTo("sync")
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "options-button-icon lite-sync-with"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "options-button-text" }, [
                          _vm._v(_vm._s(_vm.$t("language.common.syncWith")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showBackupTo(),
                            expression: "showBackupTo()"
                          }
                        ],
                        staticClass: "options-button",
                        on: {
                          click: function($event) {
                            return _vm.selectTaskTo("backup")
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "options-button-icon lite-backup-to"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "options-button-text" }, [
                          _vm._v(_vm._s(_vm.$t("language.common.backupTo")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showDownload(),
                            expression: "showDownload()"
                          }
                        ],
                        staticClass: "options-button",
                        on: {
                          click: function($event) {
                            return _vm.downLoadFile()
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "options-button-icon lite-download"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "options-button-text" }, [
                          _vm._v(_vm._s(_vm.$t("language.common.download")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showDelete(),
                            expression: "showDelete()"
                          }
                        ],
                        staticClass: "options-button",
                        on: {
                          click: function($event) {
                            return _vm.deleteFile()
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "options-button-icon lite-delete"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "options-button-text" }, [
                          _vm._v(_vm._s(_vm.$t("language.common.delete")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showPreview(),
                            expression: "showPreview()"
                          }
                        ],
                        staticClass: "options-button",
                        on: {
                          click: function($event) {
                            return _vm.previewFile()
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "options-button-icon lite-preview"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "options-button-text" }, [
                          _vm._v(_vm._s(_vm.$t("language.common.preview")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showRename(),
                            expression: "showRename()"
                          }
                        ],
                        staticClass: "options-button",
                        on: {
                          click: function($event) {
                            return _vm.renameFile()
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "options-button-icon lite-rename"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "options-button-text" }, [
                          _vm._v(_vm._s(_vm.$t("language.common.rename")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showCopy(),
                            expression: "showCopy()"
                          }
                        ],
                        staticClass: "options-button",
                        on: {
                          click: function($event) {
                            return _vm.copyFile()
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "options-button-icon lite-copy"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "options-button-text" }, [
                          _vm._v(_vm._s(_vm.$t("language.common.copy")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showPaste(),
                            expression: "showPaste()"
                          }
                        ],
                        staticClass: "options-button",
                        on: {
                          click: function($event) {
                            return _vm.pasteFile()
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "options-button-icon lite-paste"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "options-button-text" }, [
                          _vm._v(_vm._s(_vm.$t("language.common.paste")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showNext(),
                            expression: "showNext()"
                          }
                        ],
                        staticClass: "options-button",
                        on: {
                          click: function($event) {
                            return _vm.loadNext()
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "options-button-icon lite-next"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "options-button-text" }, [
                          _vm._v(_vm._s(_vm.$t("language.imageSaver.loadMore")))
                        ])
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "options-buttons-right" }, [
              _c("div", {
                staticClass: "refresh",
                on: {
                  click: function($event) {
                    return _vm.refresh()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                class:
                  "options-buttons" +
                  (this.multipleSelection.length > 0 ? " has-border" : "")
              },
              [
                _c("input", {
                  ref: "fileInput",
                  staticStyle: { display: "none" },
                  attrs: { type: "file", multiple: "" },
                  on: { change: _vm.handleFileChange }
                }),
                _vm._v(" "),
                _c("div", {
                  staticStyle: {
                    height: "20px",
                    width: "0px",
                    display: "inline-block"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showBucket(),
                        expression: "showBucket()"
                      }
                    ],
                    staticClass: "options-button",
                    on: {
                      click: function($event) {
                        return _vm.triggerBucket()
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "options-button-icon lite-bucket"
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "options-button-text" }, [
                      _vm._v(_vm._s(_vm.$t("language.cloudExploer.newBucket")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showAddPhotos(),
                        expression: "showAddPhotos()"
                      }
                    ],
                    staticClass: "options-button",
                    on: {
                      click: function($event) {
                        return _vm.triggerAddPhotos()
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "options-button-icon add-more-photos-icon"
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "options-button-text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "language.popup.cloudExploerPopup.googlePhotosV2AddMore"
                          )
                        )
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showUpload(),
                        expression: "showUpload()"
                      }
                    ],
                    staticClass: "options-button",
                    on: {
                      click: function($event) {
                        return _vm.triggerUpload()
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "options-button-icon lite-upload"
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "options-button-text" }, [
                      _vm._v(_vm._s(_vm.$t("language.cloudExploer.uploadFile")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.showUpload() && _vm.showMkdir()
                  ? _c("div", { staticClass: "btn-space" })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showMkdir(),
                        expression: "showMkdir()"
                      }
                    ],
                    staticClass: "options-button",
                    on: {
                      click: function($event) {
                        return _vm.triggerMkdir()
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "options-button-icon lite-mkdir"
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "options-button-text" }, [
                      _vm._v(_vm._s(_vm.$t("language.cloudExploer.newFolder")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.showTranTo()
                  ? _c("div", { staticClass: "btn-space" })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showTranTo(),
                        expression: "showTranTo()"
                      }
                    ],
                    staticClass: "options-button",
                    on: {
                      click: function($event) {
                        return _vm.selectTaskTo("tran")
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "options-button-icon lite-tran-to"
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "options-button-text" }, [
                      _vm._v(_vm._s(_vm.$t("language.common.tranTo")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.showSyncWith()
                  ? _c("div", { staticClass: "btn-space" })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showSyncWith(),
                        expression: "showSyncWith()"
                      }
                    ],
                    staticClass: "options-button",
                    on: {
                      click: function($event) {
                        return _vm.selectTaskTo("sync")
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "options-button-icon lite-sync-with"
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "options-button-text" }, [
                      _vm._v(_vm._s(_vm.$t("language.common.syncWith")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.showBackupTo()
                  ? _c("div", { staticClass: "btn-space" })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showBackupTo(),
                        expression: "showBackupTo()"
                      }
                    ],
                    staticClass: "options-button",
                    on: {
                      click: function($event) {
                        return _vm.selectTaskTo("backup")
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "options-button-icon lite-backup-to"
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "options-button-text" }, [
                      _vm._v(_vm._s(_vm.$t("language.common.backupTo")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.showDownload()
                  ? _c("div", { staticClass: "btn-space" })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showDownload(),
                        expression: "showDownload()"
                      }
                    ],
                    staticClass: "options-button",
                    on: {
                      click: function($event) {
                        return _vm.downLoadFile()
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "options-button-icon lite-download"
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "options-button-text" }, [
                      _vm._v(_vm._s(_vm.$t("language.common.download")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.showDelete()
                  ? _c("div", { staticClass: "btn-space" })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showDelete(),
                        expression: "showDelete()"
                      }
                    ],
                    staticClass: "options-button",
                    on: {
                      click: function($event) {
                        return _vm.deleteFile()
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "options-button-icon lite-delete"
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "options-button-text" }, [
                      _vm._v(_vm._s(_vm.$t("language.common.delete")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.showPreview()
                  ? _c("div", { staticClass: "btn-space" })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showPreview(),
                        expression: "showPreview()"
                      }
                    ],
                    staticClass: "options-button",
                    on: {
                      click: function($event) {
                        return _vm.previewFile()
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "options-button-icon lite-preview"
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "options-button-text" }, [
                      _vm._v(_vm._s(_vm.$t("language.common.preview")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.showRename()
                  ? _c("div", { staticClass: "btn-space" })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showRename(),
                        expression: "showRename()"
                      }
                    ],
                    staticClass: "options-button",
                    on: {
                      click: function($event) {
                        return _vm.renameFile()
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "options-button-icon lite-rename"
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "options-button-text" }, [
                      _vm._v(_vm._s(_vm.$t("language.common.rename")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.showCopy()
                  ? _c("div", { staticClass: "btn-space" })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showCopy(),
                        expression: "showCopy()"
                      }
                    ],
                    staticClass: "options-button",
                    on: {
                      click: function($event) {
                        return _vm.copyFile()
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "options-button-icon lite-copy" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "options-button-text" }, [
                      _vm._v(_vm._s(_vm.$t("language.common.copy")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.showPaste()
                  ? _c("div", { staticClass: "btn-space" })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-tooltip",
                  { attrs: { effect: "light", placement: "bottom" } },
                  [
                    _c("template", { slot: "content" }, [
                      _c(
                        "div",
                        { staticClass: "copy_nodes myscroll" },
                        _vm._l(_vm.copyNodes, function(copyNode, index) {
                          return _c(
                            "div",
                            { key: copyNode.id, staticClass: "copy_node" },
                            [
                              copyNode.dir
                                ? _c("div", { staticClass: "copy_node_name" }, [
                                    _c(
                                      "b",
                                      { staticClass: "copy_node_index" },
                                      [_vm._v(_vm._s(index + 1))]
                                    ),
                                    _c("b", [_vm._v(_vm._s(copyNode.name))])
                                  ])
                                : _c("div", { staticClass: "copy_node_name" }, [
                                    _c(
                                      "b",
                                      { staticClass: "copy_node_index" },
                                      [_vm._v(_vm._s(index + 1))]
                                    ),
                                    _vm._v(_vm._s(copyNode.name))
                                  ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "copy_node_size" }, [
                                _vm._v(_vm._s(_vm.formatBytes(copyNode.size)))
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showPaste(),
                            expression: "showPaste()"
                          }
                        ],
                        staticClass: "options-button",
                        on: {
                          click: function($event) {
                            return _vm.pasteFile()
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "options-button-icon lite-paste"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "options-button-text" }, [
                          _vm._v(_vm._s(_vm.$t("language.common.paste")))
                        ])
                      ]
                    )
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.showNext()
                  ? _c("div", { staticClass: "btn-space" })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showNext(),
                        expression: "showNext()"
                      }
                    ],
                    staticClass: "options-button",
                    on: {
                      click: function($event) {
                        return _vm.loadNext()
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "options-button-icon lite-next" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "options-button-text" }, [
                      _vm._v(_vm._s(_vm.$t("language.imageSaver.loadMore")))
                    ])
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-table",
              {
                ref: "filesTable",
                staticClass: "lite-file-table",
                attrs: {
                  data: _vm.curResult,
                  "empty-text": " ",
                  "cell-class-name": _vm.liteFileCellClass,
                  stripe: "",
                  height: "600px"
                },
                on: {
                  "row-dblclick": _vm.onRowDbClick,
                  "row-click": _vm.onRowClick,
                  "row-contextmenu": _vm.onRowRightClick,
                  "selection-change": _vm.handleSelectionChange
                },
                nativeOn: {
                  contextmenu: function($event) {
                    $event.preventDefault()
                    return _vm.onTableRightClick($event)
                  }
                }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    type: "selection",
                    width: "42",
                    align: "center",
                    "header-align": "center"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("language.common.fileName"),
                    "min-width": "336px",
                    "show-overflow-tooltip": "",
                    sortable: "",
                    "sort-method": function(a, b) {
                      var nameA =
                        a.name !== undefined && a.name !== null
                          ? String(a.name).toLowerCase()
                          : ""
                      var nameB =
                        b.name !== undefined && b.name !== null
                          ? String(b.name).toLowerCase()
                          : ""
                      if (nameA < nameB) {
                        return -1
                      }
                      if (nameA > nameB) {
                        return 1
                      }
                      return 0
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("div", [
                            _c("img", {
                              staticClass: "lite-file-icon",
                              attrs: {
                                src:
                                  "/static/file/" +
                                  _vm.getNodeIcon(scope.row) +
                                  ".svg",
                                draggable: "false"
                              },
                              on: {
                                error: function(e) {
                                  return (e.target.src =
                                    "/static/file/file.svg")
                                }
                              }
                            }),
                            _vm._v(" "),
                            scope.row.dir
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "lite-file-name",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.openFolder(
                                          _vm.$store.state.curDriveId,
                                          scope.row,
                                          null
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(scope.row.name))]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticClass: "lite-file-name",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.previewFile(scope.row)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(scope.row.name))]
                                )
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("language.common.size"),
                    sortable: "",
                    "sort-method": function(a, b) {
                      var sizeA =
                        a.size !== undefined && a.size !== null ? a.size : -1
                      var sizeB =
                        b.size !== undefined && b.size !== null ? b.size : -1
                      return sizeA - sizeB
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.formatBytes(scope.row.size)) +
                              "\n                "
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    "min-width": "130px",
                    label: _vm.$t("language.common.dateModified"),
                    sortable: "",
                    "sort-method": function(a, b) {
                      var timeA =
                        a.time !== undefined && a.time !== null
                          ? new Date(a.time).getTime()
                          : -1
                      var timeB =
                        b.time !== undefined && b.time !== null
                          ? new Date(b.time).getTime()
                          : -1
                      return timeA - timeB
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.formatDate(scope.row.time)) +
                              "\n                "
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "data-details" }, [
              _c("div", { staticClass: "data-details-count" }, [
                _vm._v(
                  _vm._s(_vm.multipleSelection.length) +
                    " / " +
                    _vm._s(_vm.curResult.length) +
                    " " +
                    _vm._s(_vm.$t("language.common.itemsSelected"))
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "data-details-size" }, [
                _vm._v(
                  _vm._s(_vm.formatBytes(_vm.selectFileSize())) +
                    " / " +
                    _vm._s(_vm.formatBytes(_vm.totalFileSize()))
                )
              ]),
              _vm._v(" "),
              _vm.uploadFiles.length > 0
                ? _c("div", {
                    staticClass: "upload-list-icon",
                    on: {
                      click: function($event) {
                        _vm.showUploadList = !_vm.showUploadList
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "upload-list-box",
                  style: { height: _vm.showUploadList ? "245px" : "0px" }
                },
                [
                  _c("div", { staticClass: "upload-list-title" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("language.popup.progressBox")) +
                          " " +
                          _vm._s(_vm.uploadedCount) +
                          " / " +
                          _vm._s(_vm.uploadFiles.length)
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "upload-list-close",
                      on: {
                        click: function($event) {
                          _vm.showUploadList = false
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "uploadList",
                      staticClass: "upload-list-items myscroll"
                    },
                    _vm._l(_vm.uploadFiles, function(file, index) {
                      return _c(
                        "div",
                        { staticClass: "upload-list-item" },
                        [
                          _c("div", { staticClass: "upload-list-name" }, [
                            _vm._v(_vm._s(file.name))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "upload-list-size" }, [
                            _vm._v(_vm._s(_vm.formatBytes(file.size)))
                          ]),
                          _vm._v(" "),
                          file.status == undefined
                            ? _c("i", {
                                staticClass: "el-icon-top",
                                staticStyle: { color: "#909399" }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          file.status == undefined
                            ? _c("i", {
                                staticClass: "el-icon-circle-close",
                                staticStyle: { color: "#909399" },
                                on: {
                                  click: function($event) {
                                    return _vm.cancelUpload(index)
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          file.status == "loading" && !_vm.uploading.readDone
                            ? _c("i", {
                                staticClass: "el-icon-loading",
                                staticStyle: { color: "#5562B4" },
                                attrs: {
                                  title: "Ready: " + _vm.uploading.status
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          file.status == "loading" && _vm.uploading.readDone
                            ? _c("el-progress", {
                                attrs: {
                                  type: "circle",
                                  percentage: parseInt(_vm.uploading.status),
                                  "show-text": false,
                                  width: 20,
                                  "stroke-width": 2,
                                  color: "#5562B4",
                                  title: "Uploading: " + _vm.uploading.status
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          file.status == "success"
                            ? _c("i", {
                                staticClass: "el-icon-success",
                                staticStyle: { color: "#67C23A" }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          file.status == "error"
                            ? _c("i", {
                                staticClass: "el-icon-warning",
                                staticStyle: { color: "#F56C6C" },
                                attrs: { title: file.msg }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    0
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.fullscreenLoading,
                  expression: "fullscreenLoading"
                }
              ],
              staticClass: "lite-file-loading"
            }),
            _vm._v(" "),
            _c("liteInput", {
              ref: "inputPopup",
              attrs: { data: _vm.input_popup_data },
              on: { ok: _vm.inputPopupOK }
            }),
            _vm._v(" "),
            _c("liteConfirmCheck", {
              ref: "confirmCheckPopup",
              attrs: { data: _vm.confirm_check_popup_data },
              on: { ok: _vm.confirmCheckPopupOK }
            }),
            _vm._v(" "),
            _c("liteConfirm", {
              ref: "confirmPopup",
              attrs: { data: _vm.confirm_popup_data },
              on: { ok: _vm.confirmPopupOK }
            }),
            _vm._v(" "),
            _c("litePreview", {
              ref: "previewPopup",
              attrs: { files: _vm.curResult }
            }),
            _vm._v(" "),
            _c("liteSelect", {
              ref: "taskToTree",
              attrs: {
                showCheckbox: false,
                showDBDrive: false,
                showEmailDrive: false,
                showFileNode: false,
                showNewFolder: true
              },
              on: { selectDone: _vm.selectDoneTo }
            })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e088213", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e088213","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/lite_file.vue
// module id = null
// module chunks = 